import { useEffect } from "react"


const Thanks = ({ isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Thanks__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Thanks__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Thanks__Background__Image' />
                )}
            </div>

            {/* Contenido */}
            <section className="Screen__Thanks__Container Container-FullHeight">
                <div className="Screen__Thanks__Container__Info">
                    {/* <img src="/img/page/xolos-five.png" className="Screen__Wait__Container__Info__Image" alt="Logo" /> */}
                    <p className="Welcome__Icon" style={{ fontSize: '9em', marginBottom: '0' }}><i className="bi bi-chat-square-heart"></i></p>
                    <p className="Screen__Thanks__Container__Title">Muchas gracias por participar</p>
                    <p className="Screen__Thanks__Container__Text">Nos vemos en el próximo partido</p>
                </div>
            </section>
            
            {/* Pie de página */}
            <p className='Screen__Thanks__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </p>
        </>
    )
}

export { Thanks };